(function () {
  angular
    .module("akitabox.qrCode")
    .controller("QRCodeController", QRCodeController);

  /** @ngInject */
  function QRCodeController(
    // Angular
    $location,
    // Resolves
    qrCode,
    // Services
    Router,
    // Dialogs
    QrPinSearchDialog
  ) {
    QrPinSearchDialog.show({ locals: { code: qrCode._code } })
      .then(function (pin) {
        $location.path("/m" + pin.uri);
        return pin;
      })
      .catch(function () {
        Router.go("app.dashboard");
      });
  }
})();
